// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"379":"caf35385","703":"2561eb53","787":"8ae8d3ca"}[chunkId] + ".chunk.js";
};